export var LIVE_WINDOW_MINUTES = 45;
export function getEventEnd(event) {
    return new Date(new Date(event.date).getTime() + LIVE_WINDOW_MINUTES * 60000);
}
export function findNextEvent(events) {
    var now = new Date().getTime();
    var next = null;
    for (var i = 0; i < events.length; i++) {
        var event_1 = events[i];
        if (getEventEnd(event_1).getTime() < now) {
            continue;
        }
        if (next === null || new Date(event_1.date).getTime() < new Date(next.date).getTime()) {
            next = event_1;
        }
    }
    return next;
}
